<!--<as-split-->
<!--  direction="horizontal"-->
<!--  (dragEnd)="split_dragEnd($event)"-->
<!--  (transitionEnd)="split_transitionEnd($event)"-->
<!--&gt;-->
<!--  <as-split-area [size]="60">-->
<!--    <app-employee-list (mySelected)="list_onSelected($event)"></app-employee-list>-->
<!--  </as-split-area>-->

<!--  <as-split-area [size]="40">-->
<!--    <app-employee-details [modelId]="selectedId$ | async"></app-employee-details>-->
<!--  </as-split-area>-->
<!--</as-split>-->

<kendo-splitter>
  <kendo-splitter-pane [scrollable]="false">
    <app-employee-perf-list
      (mySelected)="list_onSelected($event)"
      (mySelectedRange)="range_onSelected($event)"></app-employee-perf-list>
  </kendo-splitter-pane>

  <kendo-splitter-pane [collapsible]="true" [scrollable]="false" size="40%">
    <app-employee-perf-details
      [employeeId]="selectedId$ | async"
      [selectedRange]="selectedRange$ | async"></app-employee-perf-details>
  </kendo-splitter-pane>
</kendo-splitter>

